import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { MapPinPlus } from "lucide-react";
import { useFetch } from "@/lib/hooks";
import { fdate } from "@/lib/api";
import { PageHeader, StatusBadge, Empty, Loading, DemoBadge, LiveIndicator } from "@/components/common";

export default function MyReports() {
  const navigate = useNavigate();
  const { data, loading, lastSync } = useFetch("/reports/mine", { poll: 8000 });
  const [q, setQ] = useState("");
  const rows = (data || []).filter((r) => !q || `${r.folio} ${r.category_label} ${r.municipio}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div>
      <PageHeader eyebrow="Comunidad" title="Mis reportes" subtitle="Seguimiento de todos tus folios con estatus en vivo."
        actions={<><LiveIndicator lastSync={lastSync} /><Button onClick={() => navigate("/app/reportar")} data-testid="myreports-new-button"><MapPinPlus className="h-4 w-4 mr-1" />Nuevo</Button></>} />
      <Card><CardContent className="p-4">
        <Input placeholder="Buscar por folio, categoría o municipio" value={q} onChange={(e) => setQ(e.target.value)} className="mb-4 max-w-sm" data-testid="myreports-search-input" />
        {loading ? <Loading /> : rows.length === 0 ? <Empty title="Sin reportes" hint="Crea tu primer reporte para verlo aquí." /> : (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader><TableRow><TableHead>Folio</TableHead><TableHead>Categoría</TableHead><TableHead className="hidden md:table-cell">Municipio</TableHead><TableHead className="hidden md:table-cell">Fecha</TableHead><TableHead>Estatus</TableHead></TableRow></TableHeader>
              <TableBody>
                {rows.map((r) => (
                  <TableRow key={r.folio} className="cursor-pointer hover:bg-secondary/60" onClick={() => navigate(`/app/reportes/${r.folio}`)} data-testid={`myreports-row-${r.folio}`}>
                    <TableCell className="font-mono text-xs">{r.folio}</TableCell>
                    <TableCell>{r.category_label} {r.is_demo && <DemoBadge />}</TableCell>
                    <TableCell className="hidden md:table-cell">{r.municipio}</TableCell>
                    <TableCell className="hidden md:table-cell text-xs">{fdate(r.created_at)}</TableCell>
                    <TableCell><StatusBadge status={r.status} /></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </CardContent></Card>
    </div>
  );
}
